import { toast } from '@webapp/components/Notification'
import { getApiDetailMessage } from '@webapp/core/utils/errors/getApiDetailMessage'
import { useProcurifyIntl } from '@webapp/hooks'
import { useMutatePOPDFHiddenCustomFields } from '@webapp/modules/purchasing/features/toggle-po-pdf-custom-field-display/models'
// eslint-disable-next-line import/no-internal-modules
import { type POPDFHiddenCustomField } from '@webapp/platform/iam/entities/SystemPreference'
import messages from './messages'

export const useTogglePOPDFCustomFieldDisplayPresenter = () => {
  const intl = useProcurifyIntl()
  const { mutateAsync, isLoading } = useMutatePOPDFHiddenCustomFields()

  const toggle = async (hiddenMap: POPDFHiddenCustomField[]) => {
    try {
      await mutateAsync(hiddenMap)

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successfulUpdate),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getApiDetailMessage(error) ??
          intl.formatMessage(messages.failedUpdate),
      })

      // Re-throw so the Feature Set can revert its optimistic flip (BHV-046)
      throw error
    }
  }

  return {
    commands: {
      toggle,
    },
    states: {
      isSaving: isLoading,
    },
  }
}
